export const formatNumber = (value: number, decimals: number) => {
  return Number(value.toFixed(decimals));
};

export const fahrenheitToCelsius = (value: number) => {
  return (value - 32) / 1.8;
};

export const celsiusToFahrenheit = (value: number) => {
  return value * 1.8 + 32;
};
// --- Temperature conversion helpers ---
export function relativeKelvinToFahrenheit(k: number) {
  return k * 1.8;
}

export function relativeFahrenheitToKelvin(f: number) {
  return f / 1.8;
}

export const getTemperature = (
  value: number,
  temperatureUnit: TemperatureUnit
) => {
  switch (temperatureUnit) {
    case '°C':
      return value;
    case '°F':
      return celsiusToFahrenheit(value);
    case 'K':
      return relativeKelvinToFahrenheit(value);
    default:
      return value;
  }
};

export type TemperatureUnit = '°F' | '°C' | 'K';
